import styled from 'styled-components';

const StyledLineProgressionChartWrapper = styled.div`
  width: 100%;
  min-height: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
`;

const StyledLineProgressionChartSvg = styled.div`
  position: relative;
  width: ${(props) => props.width + 'px'};
  height: ${(props) => props.height + 'px'};
`;

const StyledProgressBar = styled.rect`
  transition: all 0.3s ease-in-out;
`;

const StyledProgressBarFill = styled.rect`
  transition: all 0.3s ease-in-out;
  animation: progressFill 0.8s ease-out;

  @keyframes progressFill {
    from {
      width: 0;
    }
    to {
      width: ${(props) => props.width || '0px'};
    }
  }
`;

const StyledProgressBarBackground = styled.rect`
  transition: all 0.3s ease-in-out;
`;

export {
  StyledLineProgressionChartWrapper,
  StyledLineProgressionChartSvg,
  StyledProgressBar,
  StyledProgressBarFill,
  StyledProgressBarBackground
};
